/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  GetTransactionInfoT,
  getTransactionInfoDefaultDecoder,
  NewTransactionT,
  newTransactionDefaultDecoder,
  CalculateFeesT,
  calculateFeesDefaultDecoder,
  GetAllPaymentMethodsT,
  getAllPaymentMethodsDefaultDecoder,
  GetPaymentMethodT,
  getPaymentMethodDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<GetTransactionInfoT> &
  TypeofApiCall<NewTransactionT> &
  TypeofApiCall<CalculateFeesT> &
  TypeofApiCall<GetAllPaymentMethodsT> &
  TypeofApiCall<GetPaymentMethodT>;

export type ParamKeys = keyof (TypeofApiParams<GetTransactionInfoT> &
  TypeofApiParams<NewTransactionT> &
  TypeofApiParams<CalculateFeesT> &
  TypeofApiParams<GetAllPaymentMethodsT> &
  TypeofApiParams<GetPaymentMethodT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | GetTransactionInfoT
  | NewTransactionT
  | CalculateFeesT
  | GetAllPaymentMethodsT
  | GetPaymentMethodT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly getTransactionInfo: TypeofApiCall<GetTransactionInfoT>;

      readonly newTransaction: TypeofApiCall<NewTransactionT>;

      readonly calculateFees: TypeofApiCall<CalculateFeesT>;

      readonly getAllPaymentMethods: TypeofApiCall<GetAllPaymentMethodsT>;

      readonly getPaymentMethod: TypeofApiCall<GetPaymentMethodT>;
    }
  : {
      readonly getTransactionInfo: TypeofApiCall<
        ReplaceRequestParams<
          GetTransactionInfoT,
          Omit<RequestParams<GetTransactionInfoT>, K>
        >
      >;

      readonly newTransaction: TypeofApiCall<
        ReplaceRequestParams<
          NewTransactionT,
          Omit<RequestParams<NewTransactionT>, K>
        >
      >;

      readonly calculateFees: TypeofApiCall<
        ReplaceRequestParams<
          CalculateFeesT,
          Omit<RequestParams<CalculateFeesT>, K>
        >
      >;

      readonly getAllPaymentMethods: TypeofApiCall<
        ReplaceRequestParams<
          GetAllPaymentMethodsT,
          Omit<RequestParams<GetAllPaymentMethodsT>, K>
        >
      >;

      readonly getPaymentMethod: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentMethodT,
          Omit<RequestParams<GetPaymentMethodT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const getTransactionInfoT: ReplaceRequestParams<
    GetTransactionInfoT,
    RequestParams<GetTransactionInfoT>
  > = {
    method: "get",

    headers: ({ ["bearerAuth"]: bearerAuth }) => ({
      Authorization: `Bearer ${bearerAuth}`
    }),
    response_decoder: getTransactionInfoDefaultDecoder(),
    url: ({ ["transactionId"]: transactionId }) =>
      `${basePath}/transactions/${transactionId}`,

    query: () => withoutUndefinedValues({})
  };
  const getTransactionInfo: TypeofApiCall<GetTransactionInfoT> = createFetchRequestForApi(
    getTransactionInfoT,
    options
  );

  const newTransactionT: ReplaceRequestParams<
    NewTransactionT,
    RequestParams<NewTransactionT>
  > = {
    method: "post",

    headers: ({
      ["x-correlation-id"]: xCorrelationId,
      ["x-client-id-from-client"]: xClientIdFromClient
    }) => ({
      "x-correlation-id": xCorrelationId,

      "x-client-id-from-client": xClientIdFromClient,

      "Content-Type": "application/json"
    }),
    response_decoder: newTransactionDefaultDecoder(),
    url: ({}) => `${basePath}/transactions`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: ({ ["recaptchaResponse"]: recaptchaResponse }) =>
      withoutUndefinedValues({ ["recaptchaResponse"]: recaptchaResponse })
  };
  const newTransaction: TypeofApiCall<NewTransactionT> = createFetchRequestForApi(
    newTransactionT,
    options
  );

  const calculateFeesT: ReplaceRequestParams<
    CalculateFeesT,
    RequestParams<CalculateFeesT>
  > = {
    method: "post",

    headers: ({
      ["bearerAuth"]: bearerAuth,
      ["x-transaction-id-from-client"]: xTransactionIdFromClient
    }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-transaction-id-from-client": xTransactionIdFromClient,

      "Content-Type": "application/json"
    }),
    response_decoder: calculateFeesDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}/fees`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: ({ ["maxOccurrences"]: maxOccurrences }) =>
      withoutUndefinedValues({ ["maxOccurrences"]: maxOccurrences })
  };
  const calculateFees: TypeofApiCall<CalculateFeesT> = createFetchRequestForApi(
    calculateFeesT,
    options
  );

  const getAllPaymentMethodsT: ReplaceRequestParams<
    GetAllPaymentMethodsT,
    RequestParams<GetAllPaymentMethodsT>
  > = {
    method: "post",

    headers: () => ({
      "Content-Type": "application/json"
    }),
    response_decoder: getAllPaymentMethodsDefaultDecoder(),
    url: ({}) => `${basePath}/payment-methods`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const getAllPaymentMethods: TypeofApiCall<GetAllPaymentMethodsT> = createFetchRequestForApi(
    getAllPaymentMethodsT,
    options
  );

  const getPaymentMethodT: ReplaceRequestParams<
    GetPaymentMethodT,
    RequestParams<GetPaymentMethodT>
  > = {
    method: "get",

    headers: ({ ["x-client-id"]: xClientId }) => ({
      "x-client-id": xClientId
    }),
    response_decoder: getPaymentMethodDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentMethod: TypeofApiCall<GetPaymentMethodT> = createFetchRequestForApi(
    getPaymentMethodT,
    options
  );

  return {
    getTransactionInfo: (withDefaults || identity)(getTransactionInfo),
    newTransaction: (withDefaults || identity)(newTransaction),
    calculateFees: (withDefaults || identity)(calculateFees),
    getAllPaymentMethods: (withDefaults || identity)(getAllPaymentMethods),
    getPaymentMethod: (withDefaults || identity)(getPaymentMethod)
  };
}
